import { render, staticRenderFns } from "./ProductKit.vue?vue&type=template&id=4db88bb8&"
import script from "./ProductKit.vue?vue&type=script&lang=js&"
export * from "./ProductKit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports